module.exports = __webpack_public_path__ + "static/media/poo-storm.aee2fdb7.svg";